import { get } from "http";
import React from "react";
import {
  ComposedChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer,
  ScatterChart,
  Scatter,
  ZAxis,
  Line
} from 'recharts';

export const renderCommonChart = (chartData: unknown[], children: React.ReactNode,
    withoutLegend?: boolean,
    tooltipFormatter?: (value: string, name: string, props: unknown) => [string, string],
    yAxisDomain?: [number, number | string],
    showSecondYAxis?: boolean,
    YAxisLabels: { left?: string, right?: string } = { left: "在庫数", right: "生産・出荷数" },
    rightAxisDomain: [number, number | string] = [0, 'auto'],
  ) => {
  if(!tooltipFormatter){
    tooltipFormatter = (value: string, name: string, props: unknown) => {
      return [value.toString(), name.toString()];
    }
  }
  if(!yAxisDomain){
    yAxisDomain = [0, 'auto'];
  }
  return (
    <ResponsiveContainer width="100%" height={400}>
      <ComposedChart data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 70 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="date"
          angle={-45}
          textAnchor="end"
          height={70}
          interval={0} // すべての日付を表示
          tick={{ fontSize: 10 }} // フォントサイズを小さくする
          tickFormatter={(date) => {
            const dayOfWeek = new Date(date).getDay();
            const dayName = ['日', '月', '火', '水', '木', '金', '土'][dayOfWeek];
            return `${date.replace(/^\d+-/,"")} (${dayName})`;
          }}
        />
        <YAxis
          yAxisId="left"
          domain={yAxisDomain as [number, number | string]}
          label={{ value: YAxisLabels.left, angle: -90, position: 'insideLeft' }}
        />
        {showSecondYAxis && (
          <YAxis
            yAxisId="right"
            orientation="right"
            domain={rightAxisDomain}
            label={{ value: YAxisLabels.right, angle: 90, position: 'insideRight' }}
          />
        )}
        {children}
        <Tooltip formatter={tooltipFormatter} />
        {!withoutLegend && <Legend wrapperStyle={{fontSize: '0.5rem'}}/>}
      </ComposedChart>
    </ResponsiveContainer>
  );
}

// カラーパレット
const colors = [
  '#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd',
  '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf'
];

const importantColors = [
  '#ff7f0e', '#d62728', '#9467bd', '#8c564b', '#e377c2',
  '#7f7f7f', '#bcbd22', '#17becf', '#1f77b4', '#2ca02c'
];

export const getChartColors = (index: number) => colors[index % colors.length];
export const getImportantChartColors = (index: number) => importantColors[index % importantColors.length];
